// John Eldhose 20190510
import React, { Component } from 'react';
import { Grid, IconButton, TextField, Typography } from '@material-ui/core';
import { Search, WebAsset } from '@material-ui/icons';
import { setLoginPage } from './lib/LoginPage';

class TeaserRenew extends Component {

  state = {
    SerialNumber: ''
  }
  componentWillMount() {
    setLoginPage({ url: '/renew' });
  }
  handleSearch = () => {
    window.location = '/signup';
  }
  handleEnter = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
      e.preventDefault();
    }
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <center><font color='#385687'>Renew / Upgrade Product</font></center>
        </Typography>
        <Grid container style={{ paddingTop: '50px' }}>
          <Grid item xs={12} sm={12} md={1} lg={1} xl={1} />
          <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
            <Grid container>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
              <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                <TextField
                  style={{ border: '1px solid silver', borderRadius: '5px', boxShadow: '1px 1px 1px 1px #888888' }}
                  fullWidth
                  autoFocus={true}
                  name='SerialNumber'
                  placeholder='Serial Number'
                  value={this.state.SerialNumber}
                  onKeyPress={this.handleEnter}
                  onChange={(e) => this.setState({ SerialNumber: e.target.value })}
                  InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                      <div style={{ backgroundColor: '#ecf0f1', padding: '10px 10px 0px 10px', borderRadius: '5px 0px 0px 5px', margin: '0px 10px 0px 0px' }}>
                        <WebAsset />
                      </div>
                    ),
                    endAdornment: (
                      <div style={{ backgroundColor: '#ecf0f1', borderRadius: '0px 5px 5px 0px' }}>
                        <IconButton onClick={this.handleSearch}>
                          <Search color='primary' />
                        </IconButton>
                      </div>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
            </Grid>
            <Typography variant='caption' style={{ textAlign: 'justify', padding: '50px 0px 10px 0px' }}>
              This page is used to renew or upgrade a single serial number. You will need a valid email address to use this form. To manage your account and to renew or upgrade multiple serial numbers in your account please gain access to your account by contacting your administrator for your corporate account or by contacting your Carlson sales support or technical support. If you already have an account please <a href='/login'>Login</a>
            </Typography>
            <Typography style={{ textAlign: 'justify', padding: '10px 0px 50px 0px' }}>
            <b>To renew multiple serial numbers</b> of Carlson field and office products, please contact <a href="http://www.carlsonsw.com/where-to-purchase/">your Carlson sales representative</a> or <a href='/login'>log in to your Carlson Customer Portal</a>.<p />

            <b>To locate your SurvCE version and serial number</b> tap “About SurvCE” from the ”Equip” tab in SurvCE. Here your version is displayed at the top. Then tap "Change Registration" to display your serial number.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={1} lg={1} xl={1} />
        </Grid>
      </div>
    );
  }
}

export default TeaserRenew



// WEBPACK FOOTER //
// ./src/components/TeaserRenew.js